import axios from 'axios';

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
if (csrfToken) axios.defaults.headers = {
  'Content-Type': 'application/json',
  'X-CSRF-Token': csrfToken,
};
